import { Component } from "react";
import Form from 'react-bootstrap/Form';

export default class extends Component {
    render() {
        return (
            <>
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, .4)', zIndex: '11111', display: this.props.visible ? 'flex' : 'none', alignItems: "center", justifyContent: "center" }}>
                    <div className={this.props.customClass}>
                        <div className="card rounded-4">
                            <div className="card-body p-lg-5 p-md-5 p-3 popup-content" style={{ fontSize: '14px' }}>
                                <button onClick={this.props.closeOTP} style={{ background: 'none', border: 'none', marginLeft: '98%', fontSize: '20px' }}><i className="fa fa-close margin-close popup-button"></i></button>
                                <Form.Select value={this.props.jenisOTP}
                                    onChange={(e) => this.props.setJenisOTP(e.currentTarget.value, e.currentTarget.value == "" ? this.props.setErrorJenisOTP('Silahkan pilih jenis OTP') : this.props.setErrorJenisOTP(''))}>
                                    <option value="">Pilih jenis OTP</option>
                                    <option value="email" disabled={!this.props.isEmailVerified}>Email</option>
                                    <option value="whatsapp" disabled={!this.props.isWhatsappVerified}>WhatsApp</option>
                                </Form.Select>
                                {this.props.errorJenisOTP != "" ?
                                    <div>
                                        <span style={{ fontSize: 12, color: 'red', marginBottom: '5px' }}>{this.props.errorJenisOTP}</span><br />
                                    </div> : ""}
                                <br />
                                <button className="btn btn-login" style={{ fontSize: '14px' }} onClick={this.props.kirimOTP}>Kirim OTP</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}